import React, { useState } from "react";
import { buildPublicAppUrl } from "../services/publicAppUrl";
import "../styles/invitations.css";

export default function InvitationLinkDisplay({ invitationId, onClose }) {
    const [copied, setCopied] = useState(false);

    if (!invitationId) {
        return null;
    }

    const link = buildPublicAppUrl(`/submit/${invitationId}`);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(link);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (error) {
            setCopied(false);
        }
    };

    return (
        <div className="invitation-link-modal">
            <div className="modal-overlay" onClick={onClose} />
            <div className="modal-card">
                <div className="modal-header">
                    <h3>Invitation link</h3>
                    <button className="modal-close" onClick={onClose}>
                        ✕
                    </button>
                </div>
                <div className="modal-body">
                    <input className="modal-link" value={link} readOnly />
                    <div className="modal-actions">
                        <button className="btn secondary-btn" onClick={handleCopy}>
                            {copied ? "Copied!" : "Copy"}
                        </button>
                        <a
                            className="btn"
                            href={link}
                            target="_blank"
                            rel="noreferrer"
                        >
                            Open link
                        </a>
                    </div>
                    <div className="qr-placeholder">QR code coming soon</div>
                </div>
            </div>
        </div>
    );
}
